'use strict';

/**
 * Подтверждение действия: окно создаётся на лету через window.openModalWindow — всегда поверх остальных окон.
 * Статической модалки в разметке больше нет; подписи для вызывающих не изменилась.
 * @param {Object} options
 * @param {string} options.message
 * @param {Function} options.callback
 * @param {Function} [options.cancelCallback]
 */
window.openConfirmModal = function (options) {
    let defaults = {
        message: 'Вы уверены?',
        callback: null,
        cancelCallback: null,
    };

    let opts = Object.assign({}, defaults, options);
    // Флаг «подтверждено»: cancelCallback срабатывает только при отмене (закрытие без подтверждения).
    let confirmed = false;

    window.openModalWindow(null, {
        title: '<i class="fas fa-exclamation-triangle me-2"></i>Подтверждение действия',
        titleClasses: 'text-danger',
        content: '<p>' + opts.message + '</p>',
        buttons: [
            {label: "Отмена", classes: "btn-secondary", onClick: "modal-hide"},
            {label: "Подтвердить", classes: "btn-danger", onClick: function (button, config) {
                confirmed = true;
                config.modal.modal('hide');
                if (typeof opts.callback === 'function') {
                    opts.callback();
                }
            }}
        ],
        onAfterClose: function () {
            if (!confirmed && typeof opts.cancelCallback === 'function') {
                opts.cancelCallback();
            }
        }
    });
};
